import { useEffect } from 'react';
import { useLocalStorage } from 'react-use';
import { CLIENT_TITLE_KEY } from './consts';
import { useBaseTitle } from './useBaseTitle';
import { useFeatureFlag } from './useFeatureFlag';

/**
 * Hook that sets the document title according to ui.ClientTitle and env.
 * Document title is persisted in localStorage and read in index.html
 *
 * Priority system:
 * 1. Client title - when ui.ClientTitle feature flag is configured
 * 2. Default "Talos" title - fallback when no client title
 */
export function useDynamicDocumentTitle() {
  const { clientTitle, isLoaded } = useFeatureFlag();
  const baseTitle = useBaseTitle();

  const [, setSavedClientTitle, removeSavedClientTitle] = useLocalStorage(CLIENT_TITLE_KEY);

  useEffect(() => {
    if (!isLoaded) {
      return;
    }

    if (clientTitle?.trim()) {
      setSavedClientTitle(baseTitle);
    } else {
      removeSavedClientTitle();
    }

    document.title = baseTitle;
  }, [baseTitle, clientTitle, setSavedClientTitle, removeSavedClientTitle, isLoaded]);
}
